import { render, staticRenderFns } from "./UserFieldGroupsOverview.vue?vue&type=template&id=cd8164ec&scoped=true&"
import script from "./UserFieldGroupsOverview.vue?vue&type=script&lang=js&"
export * from "./UserFieldGroupsOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldGroupsOverview.vue?vue&type=style&index=0&id=cd8164ec&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8164ec",
  null
  
)

export default component.exports